import React, { useEffect, useReducer } from "react";
import queryString from "query-string";
import { parseFilter } from "../../utils";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./DatagridFilters.module.sass";
import filterOperators from "./filterOperators.json";
import { SovosBox, SovosButton, SovosDatePicker, SovosDivider, SovosFilterDateRange, SovosFilterNumberRange, SovosFilterTextEntry, SovosTypography } from "mosaic-react";
import { Close } from "mosaic-react-icons";
import { useGridApiContext } from "@mui/x-data-grid";
const reducer = (state, action) => {
  const result = JSON.parse(JSON.stringify(state));
  result.lastUpdate = Date.now();
  switch (action.type) {
    case "update":
      if (action.indexes.length === 1) {
        result[action.indexes[0]] = {
          ...(result[action.indexes[0]] || {}),
          ...action.payload,
          filters: (result[action.indexes[0]] || {}).column === action.payload.column ? (result[action.indexes[0]] || {}).filters : [{
            value: ""
          }],
          operator: ""
        };
      } else if (action.indexes.length === 2) {
        const filterEntry = result[action.indexes[0]] || {
          filters: []
        };
        filterEntry.filters[action.indexes[1]] = {
          ...(filterEntry.filters[action.indexes[1]] || {}),
          ...action.payload
        };
        result[action.indexes[0]] = filterEntry;
      }
      return result;
    case "add":
      if (action.index !== undefined && action.operator === "and") {
        result.splice(action.index + 1, 0, {
          filters: [{
            value: ""
          }]
        });
      } else if (action.index !== undefined && action.operator === "or") {
        result[action.index].filters.push({
          value: ""
        });
      }
      return result;
    case "delete":
      if (action.indexes.length === 1) {
        result.splice(action.indexes[0], 1);
      } else if (action.indexes.length === 2) {
        (result[action.indexes[0]].filters || []).splice(action.indexes[1], 1);
      }
      return result;
    case "reset":
      const resetResult = action.payload ? action.payload : [{
        filters: [{
          value: ""
        }]
      }];
      resetResult.lastUpdate = Date.now();
      return resetResult;
    case "updateOperator":
      result[action.indexes[0]].operator = action.payload.value;
      return result;
    default:
      return result;
  }
};
const keyPressHandler = e => {
  e?.keyCode === 13 && document.getElementById("applyFilterButton").click();
};
const renderInputs = (type, values, list, listMapper, operator, disableOperators, indexes, dispatch, i18n, mask) => {
  const valuesArray = (values || "").split("#").map(v => listMapper?.[v] ? listMapper[v] : v);
  const autocomplete = list?.length;
  const defaultFilter = {
    id: "equals",
    name: "equals"
  };
  const options = autocomplete ? list?.map(item => {
    if (typeof item !== "object") {
      return {
        id: item,
        name: listMapper?.[item] ? listMapper[item] : item
      };
    }
    return item;
  }) : [];
  switch (type.toLowerCase()) {
    case "int":
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? null : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Operator`,
          data: [operator ? {
            id: i18n`${operator}`
          } : {
            id: `${defaultFilter.id}`
          }],
          AutocompleteProps: {
            loading: options?.length === 0,
            options: filterOperators[`${type.toLowerCase()}`],
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${eventValue.id}`
              }
            });
          }
        }), operator === "between" || operator === "not between" || disableOperators ? /*#__PURE__*/React.createElement(SovosFilterNumberRange, {
          sx: {
            "& .MuiTextField-root": {
              width: "100%"
            },
            paddingTop: "0"
          },
          onKeyDown: e => keyPressHandler(e),
          label: "",
          fromLabel: "-- From value --",
          toLabel: "-- To value --",
          data: [{
            from: valuesArray?.[0] || "",
            to: valuesArray?.[1] || ""
          }],
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${eventValue.from || ""}#${eventValue.to || ""}`
              }
            });
          }
        }) : operator === "is null" || operator === "is not null" || disableOperators ? null : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          data: valuesArray?.[0].length ? [valuesArray[0]] : [""],
          label: "",
          autoComplete: options?.length ? options : [{}],
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${eventValue}`
              }
            });
          }
        }));
      }
    case "date":
      {
        const maskToUse = mask.toLowerCase().replace("mm", "MM");
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? null : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Operator`,
          data: [operator ? {
            id: i18n`${operator}`
          } : {
            id: `${defaultFilter.id}`
          }],
          AutocompleteProps: {
            loading: options?.length === 0,
            options: filterOperators[`${type.toLowerCase()}`],
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${eventValue.id}`
              }
            });
          }
        }), operator === "between" || operator === "not between" || disableOperators ? /*#__PURE__*/React.createElement(SovosFilterDateRange, {
          label: "",
          onKeyDown: e => keyPressHandler(e),
          data: [{
            from: valuesArray[0] || null,
            to: valuesArray[1] || null
          }],
          sx: {
            paddingTop: "0"
          },
          format: maskToUse || "MM/dd/yyyy",
          fromLabel: i18n`Start Date`,
          maxDate: new Date(),
          minDate: "01/01/1900",
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${eventValue.from || null}#${eventValue.to || null}`
              }
            });
          },
          toLabel: i18n`End Date`
        }) : operator === "is null" || operator === "is not null" || disableOperators ? null : /*#__PURE__*/React.createElement(SovosDatePicker, {
          onKeyDown: e => keyPressHandler(e),
          sx: {
            height: "100%",
            justifyContent: "flex-end",
            marginTop: "4px"
          },
          className: styles["single-date-picker"],
          format: maskToUse || "MM/dd/yyyy",
          value: valuesArray[0] || null,
          onChange: e => {
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: e
              }
            });
          }
        }));
      }
    case "autosearch":
      {
        disableOperators = true;
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? null : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Operator`,
          data: [operator ? {
            id: i18n`${operator}`
          } : {
            id: i18n`${defaultFilter.id}`
          }],
          AutocompleteProps: {
            loading: options?.length === 0,
            options: filterOperators[`${type.toLowerCase()}`],
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${eventValue.id}`
              }
            });
          }
        }), operator === "is null" || operator === "is not null" ? null : ["like", "not like", "starts with", "not starts with"].includes(operator) ? /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          data: valuesArray?.[0].length ? [valuesArray[0]] : [""],
          label: "Value",
          autoComplete: options?.length ? options : [{}],
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: `${eventValue}`
              }
            });
          }
        }) : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          data: valuesArray?.[0] ? [{
            id: valuesArray[0]
          }] : [{
            id: ""
          }],
          label: i18n`Value`,
          AutocompleteProps: {
            loading: options?.length === 0,
            options,
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: eventValue.id
              }
            });
          }
        }));
      }
    default:
      {
        const typeToUse = type.toLowerCase() === "like" ? "string" : type.toLowerCase();
        return /*#__PURE__*/React.createElement(React.Fragment, null, indexes[1] !== 0 || disableOperators ? null : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Operator`,
          data: [operator ? {
            id: i18n`${operator}`
          } : {
            id: `${defaultFilter.id}`
          }],
          AutocompleteProps: {
            loading: options?.length === 0,
            options: filterOperators[`${typeToUse}`],
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "updateOperator",
              indexes,
              payload: {
                value: `${eventValue.id}`
              }
            });
          }
        }), operator === "is null" || operator === "is not null" ? null : list?.length ? /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Value`,
          data: valuesArray?.[0] ? [{
            id: valuesArray[0]
          }] : [{
            id: ""
          }],
          AutocompleteProps: {
            loading: options?.length === 0,
            options: options || [],
            getOptionLabel: option => i18n`${option.id}`,
            isOptionEqualToValue: (option, value) => option.id === value.id
          },
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: eventValue.id
              }
            });
          }
        }) : /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
          sx: {
            padding: "0px 11px",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none"
          },
          onKeyDown: e => keyPressHandler(e),
          label: i18n`Value`,
          data: valuesArray?.[0] ? [valuesArray[0]] : [""],
          onChange: e => {
            const [eventValue] = e;
            dispatch({
              type: "update",
              indexes,
              payload: {
                value: eventValue
              }
            });
          }
        }));
      }
  }
};
const renderFilters = (state, availableFilters, dispatch, i18n, gridRef) => {
  const usedColumns = new Set();
  state.forEach(({
    column
  }) => {
    if (column !== undefined) {
      usedColumns.add(column);
    }
  });
  return state.map((filterEntry, index) => {
    const {
      column,
      filters,
      operator
    } = filterEntry;
    const options = availableFilters.filter(({
      prop
    }) => prop === column || !usedColumns.has(prop)).map(({
      prop,
      type,
      name,
      list,
      listMapper,
      disableOperators = false,
      mandatory = false,
      mask
    }) => ({
      id: prop,
      name: name || prop,
      type,
      list,
      listMapper,
      disableOperators,
      mandatory,
      mask
    }));
    const currentOption = options?.find(({
      id
    }) => id === column);
    const type = (currentOption || {}).type;
    const filterValue = ((filters || [])[0] || {}).value;
    const innerFilters = (filters || []).slice(1);
    const otherFilters = innerFilters?.map((innerFilter, innerIndex) => /*#__PURE__*/React.createElement(SovosBox, {
      key: innerIndex,
      sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: "0.5rem 1rem",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(SovosBox, {
      className: styles["inputs-container"]
    }, /*#__PURE__*/React.createElement(SovosBox, {
      sx: {
        display: "flex",
        alignItems: "center",
        marginTop: "40px"
      }
    }, /*#__PURE__*/React.createElement(SovosBox, {
      className: styles["operator"]
    }, /*#__PURE__*/React.createElement(SovosTypography, {
      sx: {
        fontWeight: "bold",
        margin: "20px"
      },
      variant: "string",
      children: i18n`OR`
    })), /*#__PURE__*/React.createElement(SovosTypography, {
      variant: "string",
      sx: {
        fontWeight: "bold"
      },
      children: (currentOption || {}).name
    })), /*#__PURE__*/React.createElement(SovosBox, null, type && renderInputs(type, innerFilter.value, currentOption.list, currentOption.listMapper, operator, currentOption.disableOperators, [index, innerIndex + 1], dispatch, i18n, currentOption.mask || "dd/mm/yyyy"))), /*#__PURE__*/React.createElement(SovosBox, {
      sx: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "150px"
      }
    }, /*#__PURE__*/React.createElement(SovosButton, {
      sx: {
        marginTop: "32px",
        minWidth: "0px",
        padding: "0px 5px"
      },
      onClick: () => {
        dispatch({
          type: "delete",
          indexes: [index, innerIndex + 1]
        });
      },
      variant: "text",
      color: "error",
      size: "small"
    }, /*#__PURE__*/React.createElement(Close, null)))));
    return /*#__PURE__*/React.createElement(SovosBox, {
      key: index,
      className: styles["filter-entry"]
    }, /*#__PURE__*/React.createElement(SovosBox, {
      className: styles["filter-entry-input"]
    }, /*#__PURE__*/React.createElement(SovosBox, {
      className: styles["inputs-container"]
    }, /*#__PURE__*/React.createElement(SovosFilterTextEntry, {
      sx: {
        padding: "0px 11px",
        borderRadius: "8px 8px 0 0",
        borderBottom: "none"
      },
      label: i18n`Column`,
      data: currentOption?.id ? [{
        id: i18n`${currentOption.id}`
      }] : [{
        id: i18n`Select a column`
      }],
      AutocompleteProps: {
        loading: options?.length === 0,
        options,
        getOptionLabel: option => i18n`${option.id}`,
        isOptionEqualToValue: (option, value) => option.id === value.id
      },
      onChange: e => {
        const [eventValue] = e;
        dispatch({
          type: "update",
          indexes: [index],
          payload: {
            column: eventValue.id
          }
        });
      }
    }), /*#__PURE__*/React.createElement(SovosBox, null, type && renderInputs(type, filterValue, currentOption.list, currentOption.listMapper, operator, currentOption.disableOperators, [index, 0], dispatch, i18n, currentOption.mask || "dd/mm/yyyy", state))), /*#__PURE__*/React.createElement(SovosBox, {
      className: styles["buttons-container"]
    }, index === state.length - 1 && state.length < availableFilters.length ? /*#__PURE__*/React.createElement(SovosButton, {
      className: `${styles["button"]} ${styles["operator"]}`,
      onClick: () => {
        dispatch({
          type: "add",
          operator: "and",
          index
        });
      },
      children: i18n`AND`,
      variant: "text",
      size: "small"
    }) : null, /*#__PURE__*/React.createElement(SovosButton, {
      className: `${styles["button"]} ${styles["operator"]}`,
      onClick: () => {
        dispatch({
          type: "add",
          operator: "or",
          index
        });
      },
      children: i18n`OR`,
      variant: "text",
      size: "small"
    }), /*#__PURE__*/React.createElement(SovosButton, {
      className: `${styles["button"]} ${styles["delete"]}`,
      onClick: () => {
        if (state?.length === 1) {
          gridRef.current.hideFilterPanel();
        } else {
          dispatch({
            type: "delete",
            indexes: [index]
          });
        }
      },
      variant: "text",
      color: "error",
      size: "small"
    }, /*#__PURE__*/React.createElement(Close, null)))), otherFilters);
  });
};
const DatagridFilters = props => {
  const {
    filter,
    availableFilters,
    anchor
  } = props;
  const {
    i18n,
    history,
    location,
    goto
  } = useGlobalValue();
  const filtersObj = filter ? parseFilter(filter) : null;
  const [state, dispatch] = useReducer(reducer, filtersObj || [{
    filters: [{
      value: ""
    }]
  }]);
  const removeFilter = () => {
    dispatch({
      type: "reset"
    });
    goto && goto(null, undefined);
  };
  const updateFilter = value => {
    goto && goto(null, value, anchor);
  };
  useEffect(() => {
    const searchParams = queryString.parse(location.search);
    if (searchParams.resetFilters !== undefined && Number(searchParams.resetFilters) > (state.lastUpdate || 0)) {
      dispatch({
        type: "reset",
        payload: filtersObj && filtersObj.length ? filtersObj : [{
          filters: [{
            value: ""
          }]
        }]
      });
    }
  }, [filtersObj, state, location, history]);
  const gridRef = useGridApiContext();
  let hideFilters = false;
  let numberOfFilters;
  if (filtersObj !== null && filtersObj.length) {
    filtersObj.map(elem => {
      if (elem.filters.length >= 1) {
        hideFilters = true;
      }
    });
    numberOfFilters = filtersObj.length;
  }
  return availableFilters && availableFilters.length ? /*#__PURE__*/React.createElement(SovosBox, {
    className: styles["container"]
  }, /*#__PURE__*/React.createElement(SovosBox, {
    className: styles["filter-header"]
  }, /*#__PURE__*/React.createElement(SovosTypography, {
    sx: {
      fontWeight: "bold",
      paddingLeft: "8px"
    },
    children: "Filter"
  }), /*#__PURE__*/React.createElement(SovosBox, null, state && state.some(({
    column
  }) => column !== undefined) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SovosButton, {
    id: "applyFilterButton",
    children: i18n`Apply filters`,
    onClick: () => {
      updateFilter(state);
    },
    variant: "text"
  }), /*#__PURE__*/React.createElement(SovosButton, {
    variant: "text",
    children: i18n`Clear`,
    id: "clearFilterButton",
    onClick: removeFilter
  })) : null)), /*#__PURE__*/React.createElement(SovosDivider, null), /*#__PURE__*/React.createElement(SovosBox, {
    className: styles["filters-container"]
  }, /*#__PURE__*/React.createElement(SovosBox, null, renderFilters(state, availableFilters || [], dispatch, i18n, gridRef)))) : null;
};
export default DatagridFilters;